export enum PublicationStatus {
    OnGoing = 0,
    Hiatus = 1,
    Completed = 2,
    Cancelled = 3,
    Ended = 4
}